import classNames from 'classnames';
import { forwardRef } from 'react';
const markerCss = "m1b3otuh";
export const Marker = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    color,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const style = {
    backgroundColor: color
  };
  return <Component ref={ref} {...restProps} style={style} className={classNames(markerCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");